import {
	MenuItemType as BaseMenuItemType,
	IBaseBlockIndexResource,
	IMenuItemIndexResource,
	Id,
	TranslationEntry,
	VisibilityOption,
	defaultMenuItemTypes,
} from "@dgs/core";

const menuItemTypes = [...defaultMenuItemTypes, "PAGE"] as const;
export type MenuItemType = (typeof menuItemTypes)[number] | BaseMenuItemType;
export const initialMenuItemTypes = [...menuItemTypes];

export interface MenuItemTranslationEntry {
	name: string;
}

type MenuItemIndexResource = IMenuItemIndexResource<VisibilityOption, MenuItemType>;

export interface MenuItemUpdateResource extends Omit<MenuItemIndexResource, "name"> {
	previewBlock: IBaseBlockIndexResource | null;
	block: IBaseBlockIndexResource | null;
	translations: TranslationEntry<MenuItemTranslationEntry>[];
}

export interface MenuItemFormValues extends Omit<MenuItemIndexResource, "id" | "name"> {
	previewBlock: IBaseBlockIndexResource | null;
	block: IBaseBlockIndexResource | null;
	translations: TranslationEntry<MenuItemTranslationEntry>[];
	isTimeControlled: boolean;
	isPredefinedLink: boolean;
	isPreviewPredefinedLink: boolean;
}

export interface MenuItemSaveRequest extends Omit<MenuItemIndexResource, "id" | "name"> {
	previewBlockId: Id | null;
	blockId: Id | null;
	translations: TranslationEntry<MenuItemTranslationEntry>[];
}
